module.exports = __webpack_public_path__ + "img/yzh3.ebaceca2.jpg";